import { render, staticRenderFns } from "./fr.vue?vue&type=template&id=d9f5f2e8&scoped=true&lang=html&"
import script from "./fr.vue?vue&type=script&lang=js&"
export * from "./fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f5f2e8",
  null
  
)

export default component.exports